import { render, staticRenderFns } from "./addWashButton.vue?vue&type=template&id=3cb5328d&scoped=true&"
import script from "./addWashButton.vue?vue&type=script&lang=js&"
export * from "./addWashButton.vue?vue&type=script&lang=js&"
import style0 from "./addWashButton.vue?vue&type=style&index=0&id=3cb5328d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb5328d",
  null
  
)

export default component.exports